import { WeeklyTrialsDropInsEntity } from "@/modules/boxDashboard/modules/TrialsDropIns/entities/weeklyTrialsDropInsEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"

export function useWeeklyTrialsDropIns(startDate: string, endDate: string) {
  const { boxDashboardApi } = useServicesContext()

  const { data, error, refetch } = useSuspenseQuery({
    queryKey: ["weeklyTrialsDropIns", startDate, endDate],
    queryFn: async () => {
      const dtos = await boxDashboardApi.getTrialsDropInsBirthdays(startDate, endDate)
      return WeeklyTrialsDropInsEntity.fromDto(dtos, startDate, endDate)
    },
  })

  return {
    weekData: data,
    error,
    refetch,
  }
}
